import { createUseStyles } from 'react-jss'
import clsx from 'clsx'

const useStyles = createUseStyles({
    off: {
        position: 'absolute',
        top: '-6.1px',
        right: '0',
        zIndex:'9',
        '&:after': {
            position: 'absolute',
            content: '""',
            width: '0',
            height: '0',
            borderLeft: [45, 'solid', 'transparent'],
            borderRight: [45, 'solid', 'transparent'],
            borderTop: [10, 'solid', '#F87171'],
        },
        '& span': {
            position: 'relative',
            display: 'block',
            textAlign: 'center',
            background: 'linear-gradient(#EF4444, #F87171)',
            fontSize: '14px',
            padding: '12px 8px 10px',
            borderTopRightRadius: '6px',
            width: '90px',
            lineHeight: '1.5em',
            '&:before': {
                position: 'absolute',
                content: '""',
                height: '6px',
                width: '6px',
                left: '-6px',
                top: '0',
                background: '#991B1B',
            },
            '&:after': {
                position: 'absolute',
                content: '""',
                height: '6px',
                width: '8px',
                left: '-8px',
                top: '0',
                borderRadius: '8px 8px 0 0',
                background: '#991B1B',
            },
        },
    },
})

function Badge({ text, type = 'off' }) {
    const classes = useStyles()
    return (
        <>
            {type === 'off' && (
                <span className={clsx(classes.off, 'shadow-lg')}>
                    <span className='text-red-100'>{text}</span>
                </span>
            )}
            {type != 'off' && (
                <span className={clsx(classes.badge), 'text-xs font-semibold inline-block py-1 px-2 rounded text-indigo-600 bg-indigo-200'}>{text}</span>
            )}
        </>
    )
}

export { Badge }
